import DOMPurify from 'isomorphic-dompurify';

export default function HTMLContent({ content, className }) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content)
      }}
    />
  );
}
